/**
 * Lightweight user preferences backed by localStorage.
 */

const AUTO_CACHE_PLAYBACK_KEY = 'songkit.autoCachePlayback';

/**
 * Whether to download a full copy of each played track to the offline cache in
 * the background. Opt-in (default off) so users on metered/mobile connections
 * don't pay the extra bandwidth — playback streams either way, and the explicit
 * "Download Songs" action still caches in bulk.
 */
export function getAutoCachePlayback(): boolean {
  try {
    return localStorage.getItem(AUTO_CACHE_PLAYBACK_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setAutoCachePlayback(enabled: boolean): void {
  try {
    localStorage.setItem(AUTO_CACHE_PLAYBACK_KEY, enabled ? 'true' : 'false');
  } catch {
    /* ignore (private mode / storage disabled) */
  }
}
